export default __webpack_public_path__ + "static/media/peasy.411e48e0.png";